<template>
  <div
      :class="{
        'q-py-lg-sm': headerCollapsed,
        'q-py-lg-md': !headerCollapsed,
      }"
      class="c-desktop__inner"
  >
    <div class="container">
      <div class="row no-wrap items-center q-col-gutter-lg">
        <div class="col-auto">
          <router-link
              :class="['c-logo', 'flex', 'no-wrap', 'items-center', { '--collapsed': headerCollapsed }]"
              to="/"
              @click="handleLogoClick"
          >
            <img alt="Суши студио" class="__left" src="/static/img/logo-s.png">
            <img alt="Суши студио" class="__right q-ml-md" src="/static/img/logo-p-right.png" fetchpriority="high">
          </router-link>
        </div>
        <div class="col-shrink">
          <div class="q-mr-md">
            <Menu mode="slider"/>
          </div>
        </div>
        <div class="q-ml-auto">
          <CUserMenu/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CUserMenu from './UserMenu.vue'
import Menu from './Menu.vue'

// Props
defineProps<{
  headerCollapsed: boolean
}>()

// Определяем emit
const emit = defineEmits<{
  logoClick: [event: MouseEvent]
}>()

/**
 * Обработчик клика по логотипу.
 * Пробрасываем событие наверх в родительский компонент.
 */
const handleLogoClick = (event: MouseEvent) => {
  emit('logoClick', event)
}
</script>

<style lang="scss" scoped>
.c-desktop__inner {
  box-shadow: 0 4px 8px -3px rgba(34, 60, 80, 0.2);
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.c-logo {
  font-size: 0;
  line-height: 0;

  img {
    transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    height: 40px;
    vertical-align: middle;

    &.__right {
      transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  // Стили для свёрнутого состояния
  &.--collapsed {
    img {
      height: 25px;

      &.__right {
        height: 0;
        overflow: hidden;
        margin-left: 0;
      }
    }
  }
}
</style>
